export const MEMBER_STATUS = [
    { label: 'All', value: 'all' },
    { label: 'Active', value: 'live' },
    { label: 'Pending Invite', value: 'pending_invite' },
    { label: 'Suspended', value: 'delete' },
]